import React, {Component} from "react";
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Game from '../Game/Game';
import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import classes from './GamesList.module.css';
import axios from "axios";
import apiUrl from "../../shared/config";
import AnchorLink from "react-anchor-link-smooth-scroll";

class GamesList extends Component {

    state = {
        count: 0,
        authenticated: false,
        games: []
    };

    componentDidMount() {
        const url = apiUrl +'Games/getGamesList';
        const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
        const params = {
            params: {
                quantity: quantity,
                offset: this.props.gameList.offset,
                game_name_filter: this.props.gameNameFilter,
                game_description_filter: this.props.gameDescriptionFilter,
                game_type_ids_array: this.props.gameTypesFilter,
                game_publisher_ids_array: this.props.gamePublishersFilter,
                game_developer_ids_array: this.props.gameDevelopersFilter,
                game_style_id: this.props.gameStyleFilter,
                start_date: this.props.releaseStartFilter,
                end_date: this.props.releaseEndFilter,
                keyword_ids_array: this.props.keywordsFilter,
                author: this.props.authorFilter,
                order_by: this.props.order_by,
            }
        };
        axios.get(url, params)
            .then(response => {
                this.setState({games: response.data.games_array});
                this.setState({count: response.data.game_count});
                this.props.updateCount(response.data.game_count);
                this.setState({authenticated: this.props.isAuthenticated});
            }).then(
            this.props.listReloaded()
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(
            this.props.reloadList === true ||
            prevProps.gameList.offset !== this.props.gameList.offset ||
            prevProps.order_by !== this.props.order_by ||
            this.props.isAuthenticated !== this.state.authenticated
        ) {
            const url = apiUrl +'Games/getGamesList';
            this.setState({authenticated: this.props.isAuthenticated});
            const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
            const params = {
                params: {
                    quantity: quantity,
                    offset: this.props.gameList.offset,
                    game_name_filter: this.props.gameNameFilter,
                    game_description_filter: this.props.gameDescriptionFilter,
                    game_type_ids_array: this.props.gameTypesFilter,
                    game_publisher_ids_array: this.props.gamePublishersFilter,
                    game_developer_ids_array: this.props.gameDevelopersFilter,
                    game_style_id: this.props.gameStyleFilter,
                    start_date: this.props.releaseStartFilter,
                    end_date: this.props.releaseEndFilter,
                    keyword_ids_array: this.props.keywordsFilter,
                    author: this.props.authorFilter,
                    order_by: this.props.order_by,
                }
            };
            axios.get(url, params)
                .then(response => {
                    this.setState({games: response.data.games_array});
                    this.setState({count: response.data.game_count});
                    this.props.updateCount(response.data.game_count);
                })
                .then(
                    this.props.listReloaded()
                );
        }
    }

    render() {
        let newGameSlug = (
            <Col className={classes.GameListCol} key="0">
                <Game
                    selected="NewGameList"
                    key="0"
                    name="Add New Game"
                    description="Open the New Game panel to add a game."
                    clicked={() => {
                        this.props.newGame(null);
                        this.props.closeGameDetails();
                        this.props.gameSelected(null);
                    }}
                />
            </Col>
        );
        newGameSlug = (this.props.isAuthenticated ? newGameSlug : '');
        const quantity = (this.props.isAuthenticated ? this.props.gameList.quantity : this.props.gameList.quantity + 1);
        const games = this.state.games.map(game => {
            let isSelected = '';
            if(this.props.selectedGameId === game.game_id) {
                isSelected = ' selected';
            }

            return (
                <Col className={classes.GameListCol} key={game.game_id}>
                    <AnchorLink className="no-link-style" offset='80' href='#game-details'>
                    <Game
                        selected={isSelected}
                        key={game.game_id}
                        name={game.game_name}
                        description={game.game_description}
                        clicked={
                            () => {
                                this.props.gameSelected(game.game_id)
                            }
                        }
                    />
                    </AnchorLink>
                </Col>
            )
        });

        return (
            <div className={"d-flex "+classes.GameListWrapper}>
                <div className={classes.GameList}>
                    <Container fluid className={classes.GameListContainer} >
                        <Row xs={1} md={2} lg={2} xl={3} >
                            {newGameSlug}
                            {games}
                        </Row>
                        <Row className={classes.GameListPagination}>
                            <PaginationWidget
                                className="col-sm-6 align-self-center"
                                updatePage={this.props.updatePage}
                                count={this.state.count}
                                quantity={quantity}
                                offset={this.props.gameList.offset}
                            />
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}



export default GamesList;